import {connect} from 'react-redux'
import {RootState} from 'Store/Reducers'
import {
  getCandidateComments,
  getCandidateHistory,
  getConversationByUserIds,
  selectConversation,
  resetMessageCenterData,
  sendRequestContact,
} from 'Store/Actions'
import {AppDispatch} from 'Store'
import {CandidateSearchSidebarContent} from './CandidateSearchSidebarContent'
import {ConversationType, SendRequestContactType} from 'Interfaces'

const mapStateToProps = (state: RootState) => ({
  candidateBasicData: state.widgetBar.data.candidateBasicData,
  comments: state.widgetBar.data.comments,
  history: state.widgetBar.data.history,
  openedConversation: state.messageCenter.data[0],
  messages: state.messageCenter.openedConversation?.messages,
  request: state.widgetBar.data.request,
  isRecruiter: state.auth.data?.role === 'recruiter',
})

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  getCandidateComments: (id: string) => dispatch(getCandidateComments(id)),
  getCandidateHistory: (id: string) => dispatch(getCandidateHistory(id)),
  getConversationByUserIds: (query: string) =>
    dispatch(getConversationByUserIds(query)),
  selectConversation: (conversation?: ConversationType) =>
    dispatch(selectConversation(conversation)),
  resetMessageCenterData: () => dispatch(resetMessageCenterData()),
  sendRequestContact: (value: SendRequestContactType) =>
    dispatch(sendRequestContact(value)),
})

export const CandidateSearchSidebarContentContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CandidateSearchSidebarContent)
